const AccentIds = {
  'arrows.simple-1': 'arrows--simple-01',
  'arrows.simple-2': 'arrows--simple-02',
  'arrows.simple-3': 'arrows--simple-03',
  'arrows.simple-4': 'arrows--simple-04',
  'arrows.simple-5': 'arrows--simple-05',
  'arrows.squiggle-small': 'arrows--squiggle-small',
  'arrows.squiggle-medium': 'arrows--squiggle-medium',
  'arrows.squiggle-large': 'arrows--squiggle-large',
  'arrows.trio': 'arrows--trio',
  'emphasise.3': 'emphasise--3',
  'emphasise.arc': 'emphasise--arc',
  'emphasise.pigs-tail': 'emphasise--pigs-tail',
  'emphasise.ray': 'emphasise--ray',
  'emphasise.wave': 'emphasise--wave',
  'circle.double': 'circle--double',
  'circle.multiple': 'circle--multiple',
  'circle.single': 'circle--single',
  'underline.double': 'underline--double',
  'underline.double-thin': 'underline--double-thin',
  'underline.long': 'underline--single-long',
  'underline.short': 'underline--single-short',
  'underline.thick': 'underline--thick',
  'underline.wave': 'underline--wave',
  frame: 'frame',
  panel: 'panel',
};

type AccentType = keyof typeof AccentIds;

interface AccentProps {
  [name: string]: any;
}

const BaseAccent = ({ variant, ...rest }: { variant: AccentType }) => (
  <svg {...rest} aria-hidden="true">
    <use href={`/images/accents.svg#${AccentIds[variant]}`} />
  </svg>
);

interface ArrowProps extends AccentProps {
  variant:
    | 'simple-1'
    | 'simple-2'
    | 'simple-3'
    | 'simple-4'
    | 'simple-5'
    | 'squiggle-small'
    | 'squiggle-medium'
    | 'squiggle-large'
    | 'trio';
}

export const Arrows = ({ variant, ...rest }: ArrowProps) => (
  <BaseAccent variant={`arrows.${variant}` as const} {...rest} />
);

interface CircleProps extends AccentProps {
  variant: 'single' | 'double' | 'multiple';
}

export const Circle = ({ variant, ...rest }: CircleProps) => (
  <BaseAccent variant={`circle.${variant}` as const} {...rest} />
);

interface EmphasiseProps extends AccentProps {
  variant: '3' | 'arc' | 'pigs-tail' | 'ray' | 'wave';
}

export const Emphasise = ({ variant, ...rest }: EmphasiseProps) => (
  <BaseAccent variant={`emphasise.${variant}` as const} {...rest} />
);

interface UnderlineProps extends AccentProps {
  variant: 'short' | 'long' | 'double' | 'double-thin' | 'thick' | 'wave';
}

export const Underline = ({ variant, ...rest }: UnderlineProps) => (
  <BaseAccent variant={`underline.${variant}` as const} {...rest} />
);

export const Frame = (props) => <BaseAccent variant="frame" {...props} />;

export const Panel = (props) => <BaseAccent variant="panel" {...props} />;
